import constants from '@/constants';

/**
 * Get status configuration for corporate requests
 * @param {string} status - Status value (pending, contacted, converted, rejected)
 * @returns {Object} Status configuration with text, cssClass, colors
 */
export function getStatusConfig(status) {
    return (
        constants.CORPORATE_REQUEST_STATUS_CONFIG[status] || {
            text: status,
            cssClass: 'status_badge',
        }
    );
}
